import { bannerZoneServices } from './../Services/bannerZoneServices.service';
import { OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Component,  ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { ActionService } from './action.service';
import { MainService } from '../Services/service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app_mobile.component.html',
  styleUrls: ['./app_mobile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppMobileComponent implements OnInit{
  title = 'WickedMobile';

  openedSubject = new Subject<boolean>();
  public sideNavDisplay = true;


  constructor(public router: Router, private _actionService: ActionService, public mainService: MainService, public bannersService: bannerZoneServices){
  }

  ngOnInit() {
    this.bannersService.getAllUserBaners(1);
  }

  dismissSidenav(data: boolean): void {
    this._actionService.sideNavDisplayChange(data);
  }

}
